import React from 'react'
import './PageHeading.scss'
export default function PageHeading({title, subtitle}) {
    return (
        <div className="page-heading-wrap">
            {
                title && 
                <h4 className="section-title heading bold primary-text-color" dangerouslySetInnerHTML={{ __html: title }} />
            }
            {
                subtitle && 
                <div className="section-intro body primary-text-color" dangerouslySetInnerHTML={{ __html: subtitle }} />
            }
        </div>
    )
}
